import { MousePosition, MousePositionOffPage, MousePositionOnPage } from "../types";

export const isMouseOnPage = (position: MousePosition): position is MousePositionOnPage => {
  return "page" in position;
};
export const isMouseOffPage = (position: MousePosition): position is MousePositionOffPage => {
  return !isMouseOnPage(position);
};

const xmlTestDoc = document.implementation.createDocument(null, null, null);
const testRoot = xmlTestDoc.createElement("root");
export const isValidXml = (input: string): boolean => {
  return true;
  // It's not clear what this function was protecting against and its name does not match what it does.
  try {
    const cleanInput = input.trim();
    if (cleanInput.length > 0) {
      testRoot.innerHTML = cleanInput;
    }
    return true;
  } catch (_err) {
    console.log(input);
    console.log(_err);
    return false;
  }
};
